// // import React from "react";
// // import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// // import Header from "./components/Header";
// // import Hero from "./components/Hero";
// // import Services from "./components/Services";
// // import Clients from "./components/Clients";
// // import Footer from "./components/Footer";
// // import "./App.css";
// // import WhyUs from "./components/WhyUs";
// // import WhatWeDo from "./components/WhatWeDo";
// // import Solutions from "./components/Solutions";
// // import AboutUs from "./components/AboutUs";
// // import Portfolio from "./components/Portfolio";

// // // Individual service pages
// // import BookWriting from "./components/BookWriting";
// // // import LayoutServices from "./components/LayoutServices";
// // // import IllustrationServices from "./components/IllustrationServices";
// // // import VideoServices from "./components/VideoServices";
// // // import CorporateVisuals from "./components/CorporateVisuals";
// // // import Branding from "./components/Branding";
// // // import SMMServices from "./components/SMMServices";

// // function App() {
// //   return (
// //     <Router>
// //       <Header />

// //       <Routes>
// //         {/* Homepage */}
// //         <Route
// //           path="/"
// //           element={
// //             <>
// //               <Hero />
// //               <WhyUs />
// //               <WhatWeDo />
// //               <Solutions />
// //               {/* <Portfolio /> */}
// //               <Clients />
// //               <AboutUs />
// //             </>
// //           }
// //         />

// //         {/* Individual Service Pages */}
// //         <Route path="/bookwriting" element={<BookWriting />} />
// //         {/* <Route path="/layout-services" element={<LayoutServices />} />
// //         <Route path="/illustration-services" element={<IllustrationServices />} />
// //         <Route path="/video-services" element={<VideoServices />} />
// //         <Route path="/corporate-visuals" element={<CorporateVisuals />} />
// //         <Route path="/branding" element={<Branding />} />
// //         <Route path="/smm-services" element={<SMMServices />} />
// //         <Route path="/aboutus" element={<AboutUs />} /> */}
// //       </Routes>

// //       <Footer />
// //     </Router>
// //   );
// // }

// // export default App;

// import React from "react";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// import Header from "./components/Header";
// import Hero from "./components/Hero";
// import Clients from "./components/Clients";
// import Footer from "./components/Footer";
// import "./App.css";
// import WhyUs from "./components/WhyUs";
// import WhatWeDo from "./components/WhatWeDo";
// import Solutions from "./components/Solutions";
// import AboutUs from "./components/AboutUs";

// // Individual service pages
// import BookWriting from "./components/BookWriting";
// import TypesettingLayout from "./components/TypesettingLayout";
// import BrandingAdvertising from "./components/BrandingAdvertising";
// import SocialMediaMarketing from "./components/SocialMediaMarketing";

// function App() {
//   return (
//     <Router>
//       <Header />
//       <Routes>
//         <Route
//           path="/"
//           element={
//             <>
//               <Hero />
//               <WhyUs />
//               <WhatWeDo />
//               <Solutions />
//               <Clients />
//               <AboutUs />
//             </>
//           }
//         />
//         <Route path="/book-writing" element={<BookWriting />} />
//         <Route path="/typesetting-layout" element={<TypesettingLayout />} />
//         <Route path="/branding-advertising" element={<BrandingAdvertising />} />
//         <Route
//           path="/social-media-marketing"
//           element={<SocialMediaMarketing />}
//         />

//         {/* Optional About Page */}
//         <Route path="/aboutus" element={<AboutUs />} />
//       </Routes>
//       <Footer />
//     </Router>
//   );
// }

// export default App;

import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Header from "./components/Header";
import Hero from "./components/Hero";
import Clients from "./components/Clients";
import Footer from "./components/Footer";
import "./App.css";
import WhyUs from "./components/WhyUs";
import WhatWeDo from "./components/WhatWeDo";
import Solutions from "./components/Solutions";
import AboutUs from "./components/AboutUs";

import BookWriting from "./components/BookWriting";
import TypesettingLayout from "./components/TypesettingLayout";
import BrandingAdvertising from "./components/BrandingAdvertising";
import SocialMediaMarketing from "./components/SocialMediaMarketing";

import ScrollToHash from "./components/ScrollToHash";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <ScrollToHash /> {/* 🔥 THIS IS KEY */}
      <Header />
      <Routes>
        {/* Home Page */}
        <Route
          path="/"
          element={
            <div className="main-content">
              <Hero />
              <WhyUs />
              <WhatWeDo />
              <Solutions />
              <Clients />
              <AboutUs />
            </div>
          }
        />

        {/* Service Pages */}
        <Route
          path="/book-writing"
          element={
            <div className="main-content">
              <BookWriting />
            </div>
          }
        />
        <Route
          path="/typesetting-layout"
          element={
            <div className="main-content">
              <TypesettingLayout />
            </div>
          }
        />
        <Route
          path="/branding-advertising"
          element={
            <div className="main-content">
              <BrandingAdvertising />
            </div>
          }
        />
        <Route
          path="/social-media-marketing"
          element={
            <div className="main-content">
              <SocialMediaMarketing />
            </div>
          }
        />
        {/* Optional */}
        <Route path="/aboutus" element={<AboutUs />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
